import {
  HasuraDataTableColumnDef,
  DataTableEx,
  DataTableExProps,
  DataTableExRef,
  AttachmentsZone,
} from '@kirz/mui-admin';
import { Box, Button } from '@mui/material';
import React, {
  forwardRef,
  Ref,
  useContext,
  useImperativeHandle,
  useMemo,
  useRef,
} from 'react';

export const UploadsTable = forwardRef(
  (
    props: Partial<DataTableExProps> & {
      id: string;
      companyId?: number;
      filterColumns?: (
        columns: HasuraDataTableColumnDef[],
      ) => HasuraDataTableColumnDef[];
    },
    ref: Ref<DataTableExRef>,
  ) => {
    const { filterColumns, companyId, ...rest } = props;
    const tableRef = useRef<DataTableExRef>(null);

    useImperativeHandle(ref, () => tableRef.current!, []);

    const columns = useMemo<HasuraDataTableColumnDef[]>(
      () =>
        (filterColumns || ((x: HasuraDataTableColumnDef[]) => x))([
          { field: 'attachmentType', headerName: 'Bestandsmap', flex: 1 },
          {
            field: 'name',
            headerName: 'Naam',
            selector: 'publicId name extension',
            flex: 1,
            onSort(sort) {
              return [{ name: sort }];
            },
            renderCell: (params) => {
              const { name, extension } = params.row;

              return (
                <Box
                  component="a"
                  href={`/api/v1/files/${params.row.publicId}`}
                  target="_blank"
                  sx={{ color: 'inherit' }}
                >
                  {name}
                  {extension}
                </Box>
              );
            },
          },
          { field: 'createdAt', headerName: 'Gemaakt op', type: 'date' },
          {
            field: 'download',
            headerName: '',
            selector: false,
            sortable: false,
            width: 150,
            renderCell: (params) => {
              return (
                <Button
                  variant="contained"
                  size="small"
                  component="a"
                  href={`/api/v1/files/${params.row.publicId}/${params.row.name}${params.row.extension}`}
                  target="_blank"
                  download
                >
                  Download
                </Button>
              );
            },
            flex: 1,
          },
        ]),
      [filterColumns],
    );

    return (
      <DataTableEx
        {...rest}
        ref={tableRef}
        source="file"
        deletable={false}
        columns={columns}
        persistStateMode="query"
        sortBy={rest.sortBy ?? { field: 'createdAt', sort: 'desc' }}
        editable={{
          icon: 'eye',
          onEdit(row) {
            window.open(`/api/v1/files/${row.publicId}`, '_blank');
          },
        }}
        selectProps={{
          filter: {
            ...(companyId && {
              companyId: { _eq: companyId },
            }),
            ...rest.selectProps?.filter,
          },
        }}
      />
    );
  },
);
